function isZeroOrEmpty(value) {
  if (value === "" || value === null || value === undefined) return true;
  const normalized = String(value).trim().replace(",", ".");
  if (normalized === "") return true;
  const parsed = Number(normalized);
  return Number.isFinite(parsed) && parsed === 0;
}

function dispatchInput(el) {
  el.dispatchEvent(new Event("input", { bubbles: true }));
}

const listenerMap = new WeakMap();

export default {
  mounted(el) {
    const onFocus = () => {
      if (isZeroOrEmpty(el.value)) {
        el.value = "";
        dispatchInput(el);
      }
    };

    // Capture phase so existing @blur handlers (formatPrice, dll)
    // sudah melihat nilai 0, bukan string kosong.
    const onBlur = () => {
      if (el.value === "" || el.value === null) {
        el.value = "0";
        dispatchInput(el);
      }
    };

    el.addEventListener("focus", onFocus);
    el.addEventListener("blur", onBlur, true);
    listenerMap.set(el, { onFocus, onBlur });
  },
  unmounted(el) {
    const listeners = listenerMap.get(el);
    if (!listeners) return;
    el.removeEventListener("focus", listeners.onFocus);
    el.removeEventListener("blur", listeners.onBlur, true);
    listenerMap.delete(el);
  },
};
